import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { RedirectComponent } from './redirect/redirect.component';

const routes: Routes = [
  {path: 'homepage',  loadChildren: () => import('./homepage/homepage.module').then(m => m.HomepageModule)},
  {path: 'reload', canActivate: [AuthGuard], loadChildren: () => import('./reload/reload.module').then(m => m.ReloadModule)},
  {path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)},
  {path: 'terms', loadChildren: () => import('./terms/terms.module').then(m => m.TermsModule)},
  {path: 'faq', loadChildren: () => import('./faq/faq.module').then(m => m.FaqModule)},
  {path: 'privacy', loadChildren: () => import('./privacy/privacy.module').then(m => m.PrivacyModule)},
  {path: 'profile', canActivate: [AuthGuard], loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule)},
  {path: 'product/:slug/:id', canActivate: [AuthGuard], loadChildren: () => import('./product/product.module').then(m => m.ProductModule)},
  {path: 'preauth', loadChildren: () => import('./preauth/preauth.module').then(m => m.PreauthModule)},
  {path: 'treasure', loadChildren: () => import('./treasure/treasure.module').then(t => t.TreasureModule)},
  {path: 'newsroom', loadChildren: () => import('./newsroom/newsroom.module').then(m => m.NewsroomModule)},
  {path: 'redirect', component: RedirectComponent},
  {path: '', pathMatch: 'full', redirectTo: 'homepage'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload',
    scrollPositionRestoration: 'top'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
